import React, { useEffect, useMemo } from 'react';
import { DefaultRootState, useDispatch, useSelector } from 'react-redux';

import { SpotInvokeEnum } from 'common/hooks/useStream/types';

import { DerivativeInvokeEnum } from 'views/derivatives/types';

import { actionSetConnection } from './redux/socket.actions';
import { CustomerInvokeEnum } from './types';
import { ClientAreaCustomersID, customersID, sharedID } from './constants';
import { SocketContext } from './SocketContext';

const SocketProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  // const { show, hide } = usePopup();

  // const [lostConnection, setLostConnection] = useState(false);

  // const onOnline = useCallback(() => setLostConnection(false), []);
  // const onOffline = useCallback(() => setLostConnection(true), []);

  const connections = useSelector((state: DefaultRootState) => state.socketReducer.connections);
  const isAuthenticated = useSelector((state: DefaultRootState) => state.common.user.isAuthenticated);

  const isSharedHubConnected = useMemo(() => connections[sharedID], [connections]);
  const isCustomerHubConnected = useMemo(() => connections[customersID], [connections]);
  const isClientAreaHubConnected = useMemo(() => connections[ClientAreaCustomersID], [connections]);

  // useEffect(() => {
  //   window.addEventListener('online', onOnline);
  //   window.addEventListener('offline', onOffline);

  //   if (lostConnection) show(ConnectionLostPopupComponent());
  //   if (!lostConnection) hide();

  //   return () => {
  //     window.removeEventListener('online', onOnline);
  //     window.removeEventListener('offline', onOffline);
  //   };
  // }, [hide, lostConnection, onOffline, onOnline, show]);

  useEffect(() => {
    if (!isCustomerHubConnected && isAuthenticated) {
      dispatch(
        actionSetConnection({
          hub: 'hubs/customers',
          hubEvents: [
            SpotInvokeEnum.ORDER_CLOSED,
            SpotInvokeEnum.ORDER_UPDATED,
            SpotInvokeEnum.ORDER_OPENED,
            DerivativeInvokeEnum.RECEIVE_DERIVATIVE_ORDER_UPDATED,
            DerivativeInvokeEnum.RECEIVE_DERIVATIVE_ORDER_OPENED,
            DerivativeInvokeEnum.RECEIVE_DERIVATIVE_ORDER_CLOSED,
            DerivativeInvokeEnum.RECEIVE_DERIVATIVE_POSITION_CREATED,
            DerivativeInvokeEnum.RECEIVE_DERIVATIVE_POSITION_UPDATED,
            DerivativeInvokeEnum.RECEIVE_DERIVATIVE_CLOSED_POSITION_CREATED,
            DerivativeInvokeEnum.RECEIVE_DERIVATIVE_CLOSED_POSITION_UPDATED,
            DerivativeInvokeEnum.RECEIVE_DERIVATIVE_POSITION_CLOSED,
          ],
          url: '/trading-gateway',
          subscribeId: customersID,
        }),
      );
    }
    if (!isClientAreaHubConnected && isAuthenticated) {
      dispatch(
        actionSetConnection({
          hub: 'customersHub',
          hubEvents: [CustomerInvokeEnum.CUSTOMER_HUB_EVENT, CustomerInvokeEnum.TRANSFER_STATUS_UPDATED],
          url: '/client-area',
          subscribeId: ClientAreaCustomersID,
        }),
      );
    }

    if (!isSharedHubConnected) {
      dispatch(
        actionSetConnection({
          hub: 'hubs/shared',
          url: '/trading-gateway',
          subscribeId: sharedID,
          hubEvents: [],
          // onReconnecting: () => setLostConnection(true),
          // onReconnected: () => setLostConnection(false),
        }),
      );
    }
  }, [dispatch, isAuthenticated, isClientAreaHubConnected, isCustomerHubConnected, isSharedHubConnected]);

  const value = useMemo(() => ({ connections }), [connections]);

  const isPendingConnection = useMemo(() => {
    if (localStorage.getItem('runningPlaywright') === 'true') return false;

    return !connections[sharedID];
  }, [connections]);

  return <SocketContext.Provider value={value}>{isPendingConnection ? null : children}</SocketContext.Provider>;
};

export default SocketProvider;
